import { getCodesByTimeZone } from 'country-tz';

// Manual overrides for deprecated/unmapped IANA timezones that country-tz doesn't cover.
// Pacific/Midway is a deprecated alias — Midway Atoll is part of US Minor Outlying Islands (UM).
const TIMEZONE_OVERRIDES = {
    'Pacific/Midway': 'um',
};

/**
 * Get the ISO 3166-1 alpha-2 country code (lowercase) for a given IANA timezone name.
 * Returns null for UTC/GMT or any timezone with no country mapping.
 */
export const getTimezoneCountryCode = (timezone) => {
    if (!timezone) return null;
    if (TIMEZONE_OVERRIDES[timezone]) return TIMEZONE_OVERRIDES[timezone];
    try {
        const codes = getCodesByTimeZone(timezone);
        if (codes && codes.length > 0) {
            return codes[0].toLowerCase();
        }
    } catch {
        // fall through
    }
    return null;
};
